import React, { Component } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import NavigationBasicItem from './NavigationBasicItem';
import { getBoundingClientRect } from '../../utils/functions';
import DraggableList from '../dragLibrary/DraggableList';

export default class Board extends Component {

    state = {
        columns: [
            { _id: null, title: 'Base' },
            // { id: 'column-2', title: 'Column 2' },
        ],
        show: true,
        isDragging: false
    }

    // onDragUpdate = (update) => {
    //     const { destination } = update;
    //     Check if the dragged item is over a droppable
    //     const isOverDroppable = destination !== null;
    //         if (isOverDroppable) {
    //             const dropPositionX = update.source.clientOffset.x;
    //             // Check if the drop position is at least 200 pixels to the left
    //             if (dropPositionX >= 200) {
    //                 // Implement your custom styling or logic for the drop position
    //                 // ...
    //             }
    //         }
    // };

    onDragStart = (update) => {
        this.setState({ isDragging: true })
    };

    onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        // console.log(source, draggableId, destination)

        if (!destination) {
            return;
        }

        if (destination) {


            let updateList = [...this.props.list];
            // let finalIndex = result.destination.index
            let totalParent = 0
            let existingParent
            // let children = []
            // let reorderItem
            // let currentIndex

            for (let i = 0; i < this.props.list.length; i++) {
                const task = this.props.list[i];
                if (task._id !== draggableId) {
                    // parentTask = task
                    if (!task.parents) {
                        task.parents = []
                    }
                    if (task.parents.length > 0) {
                        totalParent = totalParent + 1
                    }
                } else {
                    existingParent = task.parents[0]
                    break;
                }
            }
            // let firstIndex = result.source.index + totalParent
            // if (existingParent) {
            //     firstIndex = result.source.index
            //     for (let i = 0; i < this.props.list.length; i++) {
            //         const task = this.props.list[i];
            //         if (String(task._id) === String(existingParent)) {
            //             // parentTask = task
            //             firstIndex = i + firstIndex + 1
            //         }
            //     }
            // }

            // console.log(destination.droppableId)

            // if (destination.droppableId != 'base') {
            // Drop into a child area
            const taskId = destination.droppableId;

            // console.log("Here", taskId)
            // console.log("updateList", updateList)

            const parentTask = updateList.find((task) => String(task._id) === taskId);
            // const childTasks = updateList.filter((task) => String(task.parents[0]) === taskId);
            // const childIndex = childTasks.length;
            if (draggableId != taskId) {

                updateList.forEach((item, index) => {
                    if (item._id == draggableId) {
                        item.parents = parentTask?._id ? [parentTask?._id] : []
                        // currentIndex = index
                    }
                })

                // [reorderItem] = updateList.splice(firstIndex, 1);
                // for (let i = 0; i < this.props.list.length; i++) {
                //     const task = this.props.list[i];
                //     if (String(task._id) == taskId) {
                //         // parentTask = task
                //         finalIndex = finalIndex + i + 1
                //     }
                // }

                // console.log(parentTask, reorderItem)

                // if (!reorderItem) {
                // return
                // }
                // reorderItem.parents = parentTask?._id ? [parentTask?._id] : []
                // console.log(reorderItem)
                // updateList.splice(finalIndex, 0, reorderItem);
                // console.log(updateList)

                // } else if (draggableId !== taskId && existingParent) {
                // updateList.push({
                //     id: draggableId,
                //     content: this.props.list.find((task) => task.id === draggableId).content,
                //     column: parentTask.column,
                //     parent: parentTask.id,
                // });
                // updateList.splice(result.destination.index, 0, reorderItem);
            }
            // }

            // for (let i = 0; i < updateList.length; i++) {
            //     const task = updateList[i];
            //     if (String(task.parents[0]) == draggableId) {
            //         // parentTask = task
            //         children.push(i)
            //     }
            // }
            // if (children.length > 0) {
            //     for (let i = 0; i < children.length; i++) {
            //         const child = children[i];
            //         let [reorderChild] = updateList.splice(child, 1);
            //         updateList.splice(finalIndex + 1 + i, 0, reorderChild);
            //     }
            // }

            // console.log(updateList)
            let containerBound = getBoundingClientRect(this.listContainer)
            // this.reorderChildren(result, updateList, firstIndex, finalIndex, () => {
            this.setState({ show: false, containerBound }, () => {
                this.props.updateList(updateList, () => {
                    this.setState({ show: true, containerBound: null })
                });
            })

        }
        // })
    };

    listUpdated = () => {
        let containerBound = getBoundingClientRect(this.listContainer)
        this.setState({ show: false, containerBound }, () => {
            this.setState({ show: true, containerBound: null })

        })
    }

    // reorderChildren = (result, updatedTasks, firstIndex, finalIndex,cb) => {
    //     const { source, destination, draggableId } = result;
    //     if (!destination) {
    //         return;
    //     }
    // };

    updatedata = (list, cb) => {
        this.props.updateList(list, () => {
            if (cb) {
                cb()
            }
        });

    }

    setDragInfo = (id, source) => {
        this.setState({ dragInfo: { id, source } })
    }

    updateParent = (id, parent, cb) => {
        let list = [...this.props.list];

        // console.log("updateParent", parent)

        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            if (element._id == id) {
                element.parents = parent ? [parent] : []
            }

        }

        this.setState({ list }, () => {
            cb()
        })
    }


    render() {
        return (
            <div className='w-100'>
                {/* <DraggableList onDragEnd={this.onDragEnd} onDragUpdate={this.onDragUpdate} onDragStart={this.onDragStart} > */}
                {/* <div className='w-100 ' ref={(el) => this.listContainer = el} style={{ height: this.state.containerBound?.height }}> */}

                {/* {Array.isArray(this.props.list) && this.props.list.length > 0 && this.state.show && this.state.columns.map((column) => {
                    return ( */}
                <NavigationBasicItem key={null} column={{ _id: null }} list={this.props.list} isDragging={this.state.isDragging} setPositionDiv={this.props.setPositionDiv} width={this.props.width} updatedata={this.updatedata} onDragEndAction={this.onDragEnd} setDragInfo={this.setDragInfo} dragInfo={this.state.dragInfo} updateParent={this.updateParent} openEdit={this.props.openEdit} />
                {/* )
                })} */}
                {/* </div> */}
                {/* </DraggableList> */}
            </div>
        );
    }
}